"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dutyPositions = void 0;
exports.dutyPositions = [
    'Cadet Safety NCO',
    'Cadet Activities NCO',
    'Cadet Activities Officer',
    'Cadet Administrative NCO',
    'Cadet Administrative Officer',
    'Cadet Aerospace Education NCO',
    'Cadet Aerospace Education Officer',
    'Cadet Commander',
    'Cadet Communications NCO',
    'Cadet Deputy Commander for Operations',
    'Cadet Deputy Commander for Support',
    'Cadet Drug Demand Reduction NCO',
    'Cadet Element Leader',
    'Cadet Emergency Services NCO',
    'Cadet Emergency Services Officer',
    'Cadet First Sergeant',
    'Cadet Flight Commander',
    'Cadet Flight Sergeant',
    'Cadet Historian NCO',
    'Cadet Historian Officer',
    'Cadet IT Officer NCO',
    'Cadet IT Officer',
    'Cadet Leadership NCO',
    'Cadet Leadership Officer',
    'Cadet Logistics NCO',
    'Cadet Operations NCO',
    'Cadet Operations Officer',
    'Cadet Public Affairs NCO',
    'Cadet Public Affairs Officer',
    'Cadet Recruiting NCO',
    'Cadet Recruiting Officer',
    'Cadet Safety Officer',
    'Cadet Supply NCO',
    'Cadet Supply Officer',
    'Cadet WCAC Assistant',
    'Cadet WCAC Representative',
    'Activities Officer',
    'Administrative Officer',
    'Advisor to the Commander',
    'Aerospace Education Officer',
    'Alerting Officer',
    'Cadet Activities Officer',
    'Cadet Programs Development Officer',
    'Chaplain',
    'Character Development Instructor',
    'Chief of Staff',
    'CIS Officer',
    'Command NCO',
    'Commander',
    'Communications Engineering Officer',
    'Communications Licensing Officer',
    'Communications Officer ',
    'Communications Training Officer',
    'Counterdrug Officer',
    'Cyber Education Officer',
    'Deputy Commander',
    'Deputy Commander for Cadets',
    'Deputy Commander for Seniors',
    'Director of Administration',
    'Director of Aerospace Education',
    'Director of Cadet Programs',
    'Director of Communications',
    'Director of Development',
    'Director of Education and Training',
    'Director of Emergency Services',
    'Director of Finance',
    'Director of IT',
    'Director of Logistics',
    'Director of Operations',
    'Director of Recruiting',
    'Director of Safety',
    'Disaster Preparedness Officer',
    'Disaster Relief Officer',
    'Diversity Officer',
    'Drug Demand Reduction Officer',
    'Education and Training Officer',
    'Emergency Services Officer',
    'Emergency Services Training Officer',
    'External Aerospace Education Officer',
    'Finance Officer',
    'Fitness Officer',
    'Government Relations Advisor',
    'Health Services Officer',
    'Historian',
    'Homeland Security Officer',
    'Information Technologies Officer',
    'Inspector General',
    'Internal Aerospace Education Officer',
    'Legal Officer',
    'Logistics Officer',
    'Maintenance Officer',
    'Operations Officer',
    'Personnel Officer',
    'Plans and Programs Officer',
    'Public Affairs Officer',
    'Recruiting & Retention Officer',
    'Recruiting Officer',
    'Safety Officer',
    'Search and Rescue Officer',
    'Squadron Activities Officer',
    'Squadron Leadership Officer',
    'Squadron NCO',
    'Standardization/Evaluation Officer',
    'Supply Officer',
    'Testing Officer',
    'Transportation Officer',
    'Vice Commander',
    'Web Security Administrator',
];
//# sourceMappingURL=dutyPositions.js.map